var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativeKnowledgeLightbulbSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#333062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #f5dd90; } .cls-2 { fill: #ffbc0a; } .cls-3 { fill: #a3cef1; } .cls-4 { fill: #6096ba; } .cls-5 { fill: #274c77; } ")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54 29 54 59 37 59 35 61 29 61 27 59 10 59 10 29 54 29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.6,23.55h-.01c-1.13-.36-2.34-.55-3.59-.55v26c6.63,0,12,5.37,12,12,0-6.63,5.37-12,12-12V23c-1.25,0-2.46,.19-3.59,.55-.72,.7-1.53,1.32-2.41,1.83v1.62c.55,0,1,.45,1,1v2c0,.55-.45,1-1,1h-12c-.55,0-1-.45-1-1v-2c0-.55,.45-1,1-1v-1.62c-.88-.51-1.68-1.12-2.4-1.83h-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,31c0,3.31-2.69,6-6,6s-6-2.69-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44,15c0-6.63-5.37-12-12-12s-12,5.37-12,12c0,4.44,2.42,8.31,6,10.38v1.62h12v-1.62c3.58-2.08,6-5.94,6-10.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 4,
    rx: 1,
    ry: 1,
    width: 14,
    x: 25,
    y: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.93,19.07c.34-.59,.92-.94,1.54-1,.34-.96,.53-1.99,.53-3.07s-.19-2.11-.53-3.07c-.62-.06-1.21-.41-1.54-1-.34-.59-.34-1.29-.08-1.87-1.32-1.57-3.14-2.68-5.22-3.06-.36,.52-.96,.86-1.63,.86s-1.27-.34-1.63-.86c-2.08,.39-3.9,1.5-5.22,3.06,.26,.58,.25,1.27-.08,1.87-.34,.59-.92,.94-1.54,1-.34,.96-.53,1.99-.53,3.07s.19,2.11,.53,3.07c.62,.06,1.21,.41,1.54,1,.34,.59,.34,1.29,.08,1.87,1.32,1.57,3.14,2.68,5.22,3.06,.36-.52,.96-.86,1.63-.86s1.27,.34,1.63,.86c2.08-.39,3.9-1.5,5.22-3.06-.26-.58-.25-1.27,.08-1.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32,
    cy: 15,
    r: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 25,
    width: 2,
    x: 31,
    y: 36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32,61c0-6.63-5.37-12-12-12V24l-6,2v27s12.15-3,18,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50,53V26s-6-2-6-2v25c-6.63,0-12,5.37-12,12,5.85-11,18-8,18-8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeKnowledgeLightbulbSvgrepoCom);
export default __webpack_public_path__ + "static/media/creative-knowledge-lightbulb-svgrepo-com.fd5293e0895202a95f0d71b7545be32f.svg";
export { ForwardRef as ReactComponent };